module.exports = __webpack_public_path__ + "img/review-1.2ab1d37c.png";